<!-- begin:: Content Head -->
<div class="kt-subheader kt-grid__item" [ngClass]="{'kt-container--clear': clear}" [hidden]="subheaderService.disabled$ | async" id="kt_subheader">
	<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
		<div class="kt-subheader__main">
			<h3 *ngIf="title" class="kt-subheader__title">{{title}}</h3>
			<span class="kt-subheader__separator kt-subheader__separator--v"></span>
			<span *ngIf="desc" class="kt-subheader__desc machine-info-container">
				<span matTooltip="Selected machine">{{desc}}</span>
				<button
					*ngIf="role === 'sadmin'"
					mat-icon-button
					class="copy-machine-info-btn"
					(click)="copyMachineInfo()"
					matTooltip="Copy Machine ID"
					aria-label="Copy Machine ID">
					<mat-icon>content_copy</mat-icon>
				</button>
			</span>
		</div>
	</div>
</div>
<!-- end:: Content Head -->
